<template lang="pug">
    include RegisterStep3.pug
</template>

<script>
import _ from "underscore";
import moment from "moment";
import Api from "@/components/services/Api";
import { mapState } from 'vuex';

export default {
  name: 'RegisterStep3',
  data() {
    return {
      courses: [],
      selected: null,
      category: null,
      action: null,
      uuid: "",
      callback: "/registro-profesional/selecciona-pack",
    }
  },
  computed: _.extend(mapState([
    "context", "token",
  ]), {
    valid: function() {
    },
  }),
  async created() {
    const optionsResponse = await Api.options()
    const data = optionsResponse.data
    const courses = data.courses

    // remove Población Especial and Población General
    this.courses = _.filter(courses, course => {
      if (!/^poblaci.+n (general|especial)$/i.test(course.name)) return true
      return false
    })

    // calculate action
    this.action = Api.getApiUrl() + "/esreps/register-single-form/"
    this.callback = `${window.location.protocol}//${window.location.host}/registro-profesional/selecciona-pack`

    const meResponse = await Api.me(this.token)
    const me = meResponse.data
    this.uuid = me.uuid
  },
  watch: {
    selected: function(newValue) {
      const pk = newValue
      for (const course of this.courses) {
        if (pk === course.pk) {
          const categoryValue = (course.elearning_category) ? course.elearning_category : null
          this.category = categoryValue
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "RegisterStep1";
@import "RegisterStep3";
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterStep3.vue